import React from "react";

const InputField = ({ label, error, required, className = "", ...props }) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    {label && (
      <label className="text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    )}
    <input
      className={`input-field ${error ? "border-red-400 focus:border-red-400 focus:ring-red-100" : ""}`}
      {...props}
    />
    {error && <p className="text-red-500 text-xs">{error}</p>}
  </div>
);

export const SelectField = ({ label, error, required, children, className = "", ...props }) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    {label && (
      <label className="text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    )}
    <select
      className={`input-field ${error ? "border-red-400" : ""}`}
      {...props}
    >
      {children}
    </select>
    {error && <p className="text-red-500 text-xs">{error}</p>}
  </div>
);

export default InputField;
